/**
 * Control whether to show the language selector on FE
 */
export const LANGUAGE_SELECTOR_ENABLED = 'LANGUAGE_SELECTOR_ENABLED';
